import * as React from 'react'
import Wave from 'react-wavify'
import { Action, any, IOWidget, Pair } from 'widgets-for-react';
import { fromJSX } from '../../../../../utils';
import { CustomPagesState, PublicSiteCustomRoutes } from '../../types.mod';
import { Entity } from 'ts-lenses';
import { AnimationState } from '../Fc150Years.types';
import { enableReducedMotion } from '../Fc150Years.utils';
import { CustomRouteParams } from '../../../../cms/router/type.gen';
import { PublicSiteState } from '../../../../public_site.main.mod';



export let transitionWidget = (r: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState["Fc150YearsMainPage"]>): IOWidget<CustomPagesState["Fc150YearsMainPage"], Action<CustomPagesState["Fc150YearsMainPage"]>> =>
  s0 => any<Action<CustomPagesState["Fc150YearsMainPage"]>>()([

    fromJSX(setState => {
      if (s0.current_page == "transition-page" && s0.transition.animationState == "about-to-move-up") {
        setTimeout(() => {
          setState(s0 => {
            if (s0.current_page == 'transition-page' && s0.transition.animationState != 'wave-moving-up') return s0
            window.scrollTo(0, 0)
            return Entity(s0)
              .setIn("transition", t => t.set('animationState', _ => 'wave-up' as AnimationState))
              .setIn("state", t => t.set("page", _ => s0.transition.to.state.page)) // Start page loader
              .commit()
          })
        }, s0.transition.animationTime)
        setTimeout(() => {
          setState(s0 => Entity(s0)
            .setIn("transition", t => t.set('animationState', _ => 'wave-moving-up' as AnimationState))
            .commit()),
            100
        })
      }

      if (s0.current_page == "transition-page" && s0.transition.animationState == "about-to-move-down") {
        setTimeout(() => {
          setState(s0 => {
            if (s0.current_page == 'transition-page' && s0.transition.animationState != 'wave-moving-down') return s0

            return Entity(s0)
              .set('current_page', _ => s0.transition.to.current_page)
              .set('homeState', _ => s0.transition.to.homeState)
              .set('storiesOverviewState', _ => s0.transition.to.storiesOverviewState)
              .set('storyDetailState', _ => s0.transition.to.storyDetailState)
              .commit()
          })
        }, s0.transition.animationTime)
        setTimeout(() => {
          setState(s0 => Entity(s0).setIn("transition", t => t.set('animationState', _ => 'wave-moving-down' as AnimationState)).commit()),
            100
        })
      }

      if (s0.state.page.page.kind == 'failed') {
        setState(s0 => Entity(s0).set('current_page', _ => '404' as any).commit())
      }

      return (
        <>
          <div className="pageanim" aria-hidden="true" data-state={s0.transition.animationState}>
            <div className="pageanim__waves" aria-hidden="true">
              <Wave fill='rgb(255, 255, 255, .5)'
                paused={enableReducedMotion}
                options={{
                  height: 60,
                  amplitude: 60,
                  speed: 0.1,
                  points: 8
                }}
                className="pageanim__wave"
              />
              <Wave fill='rgb(255, 255, 255, .65)'
                paused={enableReducedMotion}
                options={{
                  height: 60,
                  amplitude: 60,
                  speed: 0.1,
                  points: 5
                }}
                className="pageanim__wave"
              />
              <Wave fill='rgb(255, 255, 255, 1)'
                paused={enableReducedMotion}
                options={{
                  height: 60,
                  amplitude: 60,
                  speed: 0.1,
                  points: 6
                }}
                className="pageanim__wave"
              />
            </div>
          </div>
        </>
      )
    })

  ])
